import React, { useState } from 'react';
import {
    Modal,
    Form,
    Input,
    Select,
    DatePicker,
    Button,
    Typography,
    CreatableSelect,
    Tag,
} from '../../../../../../components';
import '../CreateAndManageModal.scss';
import { AppstoreOutlined } from '@ant-design/icons';

const { Option } = Select;
const { Title, Text } = Typography;

export const CreateMoveGroupModal = ({ open, onCancel, onApply, applications = [], users = [] }) => {
    const [form] = Form.useForm();
    const [assignedApps, setAssignedApps] = useState([]);

    const handleApplicationChange = (value) => {
        if (value && value.length > 0) {
            const newlySelectedApps = value.map((val) => {
                const existingApp = applications.find((app) => app.value === val);
                if (existingApp) {
                    return existingApp;
                } else {
                    return { value: val, label: val };
                }
            });

            setAssignedApps((prevApps) => {
                const existingIds = new Set(prevApps.map((app) => app.value));
                const appsToAdd = newlySelectedApps.filter((app) => !existingIds.has(app.value));
                return [...prevApps, ...appsToAdd];
            });
        }

        form.setFieldsValue({ applications: [] });
    };

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            const allApplicationIds = assignedApps.map((app) => app.value);
            onApply({
                ...values,
                applications: allApplicationIds,
            });
            form.resetFields();
            setAssignedApps([]);
        } catch (error) {}
    };

    const handleCancel = () => {
        form.resetFields();
        setAssignedApps([]);
        onCancel();
    };

    return (
        <Modal
            className="create-manage-modal create-move-group-modal"
            title={
                <Title level={4} className="modal-title">
                    Create Move Group
                </Title>
            }
            open={open}
            onCancel={handleCancel}
            footer={null}
            width={400}
            destroyOnHidden
        >
            <Form
                form={form}
                layout="vertical"
                initialValues={{ name: '', applications: [], user: undefined, targetMigrationDate: null }}
            >
                <Form.Item
                    label={
                        <span>
                            Name <span className="required"></span>
                        </span>
                    }
                    name="name"
                    rules={[{ required: true, message: 'Unique name required' }]}
                >
                    <Input placeholder="Create Unique Group Name" />
                </Form.Item>
                <Form.Item
                    label={
                        <span>
                            <AppstoreOutlined /> Applications
                        </span>
                    }
                    name="applications"
                >
                    <CreatableSelect
                        mode="multiple"
                        selectPlaceholder="Add Applications"
                        addItemPlaceholder="Create New Application"
                        options={applications}
                        onChange={handleApplicationChange}
                        tagRender={() => null}
                        placement="topLeft"
                    />
                </Form.Item>
                <Text type="secondary" className="assigned-apps-note">
                    Note: Applications can only belong to one move group.
                </Text>

                {assignedApps.length > 0 && (
                    <div className="assigned-apps-tags">
                        {assignedApps.map((app) => (
                            <Tag
                                key={app.value}
                                color="grey"
                                closable
                                onClose={() => {
                                    setAssignedApps((prevApps) => prevApps.filter((a) => a.value !== app.value));
                                }}
                            >
                                {app.label}
                            </Tag>
                        ))}
                    </div>
                )}
                <Form.Item label="Assigned Resource" name="user">
                    <Select placeholder="Select User" allowClear>
                        {users.map((user) => (
                            <Option key={user.value} value={user.value}>
                                {user.label}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item label="Target Migration Date" name="targetMigrationDate">
                    <DatePicker className="w-100" placeholder="Select date" />
                </Form.Item>
                <div className="button-group">
                    <Button shape="round" onClick={handleCancel}>
                        Cancel
                    </Button>
                    <Button shape="round" type="primary" onClick={handleSubmit}>
                        Apply
                    </Button>
                </div>
            </Form>
        </Modal>
    );
};
